module.exports = __webpack_public_path__ + "img/l2001.4928004e.png";